import React from 'react';
import PropTypes from 'prop-types';

import { AnimatePresence, motion } from 'framer-motion';
import i18n from 'i18next';

import { FormCallout } from 'uikit/forms';
import { Button, ButtonGroup } from 'uikit/buttons';

const CustomFilterNotice = ({
  isAnimated = true,
  isVisible = true,
  onEditClick = () => {},
  onClearClick = () => {},
  text = '',
}) => (
  <AnimatePresence>
    {isVisible && (
      <motion.div
        animate="visible"
        exit="hidden"
        initial="hidden"
        transition={{ duration: 0.2, ease: 'easeInOut' }}
        variants={{
          hidden: isAnimated && { height: 0, opacity: 0 },
          visible: { height: 'auto', opacity: 1 },
        }}
      >
        <FormCallout
          fieldId="custom-filter-callout"
          schema={{
            variant: 'ai',
            hasMarkdownText: !!text,
            heading: i18n.t('custom-filter'),
            icon: 'ai',
            text,
            actions: (
              <ButtonGroup>
                <Button
                  size="small"
                  onClick={onEditClick}
                  text={i18n.t('edit')}
                  variant="outlined"
                />
                <Button
                  size="small"
                  onClick={onClearClick}
                  text={i18n.t('clear')}
                  variant="outlined"
                />
              </ButtonGroup>
            ),
          }}
        />
      </motion.div>
    )}
  </AnimatePresence>
);

CustomFilterNotice.propTypes = {
  isAnimated: PropTypes.bool,
  isVisible: PropTypes.bool,
  onEditClick: PropTypes.func,
  onClearClick: PropTypes.func,
  text: PropTypes.string,
};

export default CustomFilterNotice;
